// removed by extract-text-webpack-plugin
module.exports = {"wdFrame":"_1t2ER5yPBLPnsr9-5Pq509"};


//////////////////
// WEBPACK FOOTER
// ./components/willdoc/willdoc.scss
// module id = 1631
// module chunks = 0